var exports = {
  "Q": "NewRulesetButtonContainer__Shpb4G",
};

module.exports = exports;
